import { render, staticRenderFns } from "./assest.vue?vue&type=template&id=149faab0&scoped=true"
import script from "./assest.vue?vue&type=script&lang=js"
export * from "./assest.vue?vue&type=script&lang=js"
import style0 from "./assest.vue?vue&type=style&index=0&id=149faab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149faab0",
  null
  
)

export default component.exports